export const PATH_HOME = '#/';
export const PATH_LEARN = '#/learn';
export const PATH_TEST = '#/test';
export const PATH_CONTACT = '#/contact';

export const PATH_VARIABLE_SUBMISSION_NUM = ':submissionNum([0-9]+)';

export const PATH_ADMIN_HOME = '#/admin';
export const PATH_ADMIN_LOGIN = `${PATH_ADMIN_HOME}/login`;
export const PATH_ADMIN_SUBMISSIONS = `${PATH_ADMIN_HOME}/submissions`;
export const PATH_ADMIN_SUBMISSION_DETAIL = `${PATH_ADMIN_HOME}/submission/${PATH_VARIABLE_SUBMISSION_NUM}`;
export const PATH_ADMIN_MANAGEMENT = `${PATH_ADMIN_HOME}/management`;
export const PATH_ADMIN_MANAGEMENT_CHANGE_PASSWORD = `${PATH_ADMIN_HOME}/management/change-password`;
